import axios from "axios";

export const getCurrentCountryCode = async () => {
  const getCountryCode = await typeof window !== undefined && localStorage.getItem("countryCode");
  if (!getCountryCode) {
    const data = await axios.get("https://ipapi.co/json/");
    localStorage.setItem("countryCode", data?.data?.country_code || "US")
    return data?.data?.country_code || "US"
  }
  return getCountryCode
}